import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import { AppSidebar } from "@/components/app-sidebar"
import { NotificationsProvider } from "@/contexts/notifications.context"
import { useAuthStore } from "@/stores/auth.store"
import { useEffect } from "react"
import { Navigate, Outlet, useNavigate } from "react-router"

export function DashboardLayout() {
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)
  const clearSession = useAuthStore((s) => s.clearSession)

  useEffect(() => {
    function handleUnauthorized() {
      clearSession()
      navigate("/auth", { replace: true })
    }
    window.addEventListener("auth:unauthorized", handleUnauthorized)
    return () => window.removeEventListener("auth:unauthorized", handleUnauthorized)
  }, [clearSession, navigate])

  if (!user) {
    return <Navigate to="/auth" replace />
  }

  return (
    <NotificationsProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset>
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </NotificationsProvider>
  )
}
